export const validateCleanPhone = (phone: string): boolean => /^\+\d{11}$/.test(phone);
